import {
  Box,
  LinearProgress,
  Typography,
  TypographyOwnProps,
} from '@mui/material'
import { JSX, ReactElement } from 'react'

function PageSection({
  children,
  title,
  loading,
  headingLevel = 'h1',
  rightDecorator,
  leftDecorator,
}: {
  children: any
  title: string | JSX.Element
  loading?: boolean
  headingLevel?: TypographyOwnProps['variant']
  leftDecorator?: ReactElement
  rightDecorator?: ReactElement
}) {
  return (
    <Box
      aria-label={title + ' Section'}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: 1,
      }}
    >
      <Box
        sx={{ py: 1, display: 'flex', justifyContent: 'space-between' }}
        width={1}
      >
        {(leftDecorator || rightDecorator) && (
          <Box
            flex={1}
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <Box>{leftDecorator}</Box>
          </Box>
        )}
        <Box
          flex={2}
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          {typeof title === 'string' ?
            <Typography
              sx={{ color: 'primary.heading' }}
              variant={headingLevel}
            >
              {title}
            </Typography>
          : title}
          {loading && (
            <LinearProgress sx={{ width: 1, mb: 1, maxWidth: 'lg' }} />
          )}
        </Box>
        {(leftDecorator || rightDecorator) && (
          <Box
            flex={1}
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <Box>{rightDecorator}</Box>
          </Box>
        )}
      </Box>
      {children}
    </Box>
  )
}

export default PageSection
